var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('e-table-list',{attrs:{"table-data":_vm.tableData,"table-label":_vm.tableLabel},scopedSlots:_vm._u([{key:"auditReportFile",fn:function(slot){return [_c('div',[_c('eui-btn',{attrs:{"type":"text"},on:{"click":function($event){return _vm.handleOpen(slot.scope.row.auditReportFile)}}},[_vm._v("查看")])],1)]}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }